import { usePlanStore } from "@/stores/plan";
import { tagColorMap } from '@/constants';

export const formatCurrency = (amount: number): string => {
  if (!amount) return '0'
  return amount
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const formatPhonNumber = (number: string): string => {
  if (number.length !== 10 && number.length !== 11) {
      return number;
    }
    const part1 = number.slice(0, 3);
    const part2 = number.slice(3, number.length - 4);
    const part3 = number.slice(number.length - 4);
    return `${part1}-${part2}-${part3}`;
}

export const disablePastDates = (date: Date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

export const getBaPlanLName = (number: number): string | undefined => {
  const plan = usePlanStore().baPlanData.find(item => item.planNumber === number);
  return plan ? plan.planName : undefined;
}

export const getBeusPlanLName = (number: number): string | undefined => {
  const plan = usePlanStore().beusPlanData.find(item => item.planNumber === number);
  return plan ? plan.planName : undefined;
}

export const getTagColor = (key : string): string => {
  return tagColorMap[key] || 'gray'
}
